import { all, put, takeLatest } from 'redux-saga/effects';
import { loadConfigAction, loadConfigSuccess } from './actions';

import api from '../../services/api';

export function* loadConfig() {
  const response: ConfigState = yield api.loadConfig();

  yield put(loadConfigSuccess(response));
}

export default all([takeLatest(loadConfigAction.request, loadConfig)]);
